'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState } from 'react';

import { IS_PRODUCTION } from '@/utils/constants';

export function ReactQueryProvider({ children }: React.PropsWithChildren) {
	const [client] = useState(
		new QueryClient({
			defaultOptions: {
				queries: {
					refetchOnWindowFocus: false
				}
			}
		})
	);

	return (
		<QueryClientProvider client={client}>
			{children}
			{!IS_PRODUCTION ? <ReactQueryDevtools initialIsOpen={false} position="bottom" /> : null}
		</QueryClientProvider>
	);
}
